import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

interface DatePickerInputProps extends ComponentPropsWithRef<"input"> {
  /* These values are passed in from the React Flatpickr library */
  onChange?: any; // eslint-disable-line @typescript-eslint/no-explicit-any -- Flatpickr library uses its own onChange signature
  value?: any; // eslint-disable-line @typescript-eslint/no-explicit-any -- Flatpickr library uses its own value type
}

export const DatePickerInput = forwardRef<
  HTMLInputElement,
  DatePickerInputProps
>((props, ref) => (
  <input
    {...props}
    className="text-darkest placeholder:text-light min-w-0 flex-1 cursor-pointer truncate border-none bg-transparent p-0 text-center text-sm font-medium placeholder:opacity-100 focus:outline-none focus:ring-0 sm:min-w-[16rem] sm:flex-none"
    ref={ref}
  />
));
DatePickerInput.displayName = "DatePickerInput";
